import { AppBar, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ErrorMessageDisplay(props) {

    

  return (
    <AppBar
      position="fixed"
      elevation={0}
      color="default"
      sx={{
        backgroundColor: "#fff",
        zIndex: 1000,
        maxWidth: { xs: "70%", md: "50%" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        left: "50%",
        top: { xs: "30%", md: "130px" },
        transform: "translate(-50%, -50%)",
        borderRadius: "12px"
      }}
    >
      <Typography variant="body2" color="red" sx={{ flexGrow: 1, marginRight:{ xs: "50px", md: "20px" } }}>
        {props.error}
      </Typography>
      <IconButton
        onClick={() => props.setMessage(false)}
        size="small"
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </AppBar>
  );
}
